'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Close = {};

exports.__exports = Close;
